"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KiloWattPerCubicFootPerMinute = exports.WattPerCubicMeterPerSecond = exports.KiloWattPerCubicMeterPerSecond = void 0;
var UnitDivide = require("../unit-divide");
var power_1 = require("./power");
var volume_flow_1 = require("./volume-flow");
// Specific Fan Power
exports.KiloWattPerCubicMeterPerSecond = UnitDivide.powerByVolumeFlow("KiloWattPerCubicMeterPerSecond", power_1.KiloWatt, volume_flow_1.CubicMeterPerSecond);
exports.WattPerCubicMeterPerSecond = UnitDivide.powerByVolumeFlow("WattPerCubicMeterPerSecond", power_1.Watt, volume_flow_1.CubicMeterPerSecond);
exports.KiloWattPerCubicFootPerMinute = UnitDivide.powerByVolumeFlow("KiloWattPerCubicFootPerMinute", power_1.KiloWatt, volume_flow_1.CubicFeetPerMinute);
//# sourceMappingURL=specific-fan-power.js.map